import React from 'react';
import { FaDownload } from 'react-icons/fa';
import Pdf from 'react-to-pdf';


const ref = React.createRef();

const PDFdownload = (props) => {
    return (
        <>
            <Pdf x={-80} y={50} scale={1} targetRef={ref} filename="CourseDetails.pdf">
                {({ toPdf }) => <button onClick={toPdf}>Download As PDF file <FaDownload></FaDownload></button>}
            </Pdf>
            <div className="Post" ref={ref}>
                <div className="m-auto mt-5 card mb-3" style={{ maxWidth: '40rem', maxHeight: '40rem' }} >
                    <div className="row g-0">
                        <div className="col-md-4 my-auto">
                            <img src={props.image} className="img-fluid rounded-start" alt="..." />
                        </div>
                        <div className="col-md-8">
                            <div className="card-body">
                                <h2 className="card-title">{props.title}</h2>
                                <small className='text-danger'>Difficulty level: {props.category}</small>
                                <p className="card-text">{props.description}</p>
                                <h3 className="card-text text-info">Price: BDT {props.price}</h3>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


        </>
    );
};

export default PDFdownload;